import { SCROLL_LAYOUT_ELEMENT_ID } from '../../layout/LayoutContainer'
import { PORTFOLIO_SCROLL_ID } from '../../portfolioInsights/common/Layout'
import { SIDE_BAR_SCROLL_ID } from './filterSetting/components/sideBar'

export const FILTER_TYPE = {
  LIBRARY: 'Library',
  PORTFOLIO_INSIGHTS: 'PortfolioInsight',
}

export const SCROLL_COMPONENT_IDS = [
  SCROLL_LAYOUT_ELEMENT_ID,
  SIDE_BAR_SCROLL_ID,
  PORTFOLIO_SCROLL_ID,
]

export const DEFAULT_PARAMS = {
  currency: 'USD',
  portfolioIds: [],
  bussinessAgeIds: [],
  bussinessSizeIds: [],
  excludeIds: [],
  industryIds: [],
  provinceIds: [],
  scoreLevel: {
    PeriodType: 1,
    LogicalOperator: 0,
    CurrentCreditRiskScore: {
      ListLevelScoreChecked: [],
      IsCustom: true,
      ListCustomRanges: [{}],
    },
    PreviousCreditRiskScore: {
      ListLevelScoreChecked: [],
      IsCustom: true,
      ListCustomRanges: [{}],
    },
    CurrentPerformanceScore: {
      ListLevelScoreChecked: [],
      IsCustom: true,
      ListCustomRanges: [{}],
    },
    PreviousPerformanceScore: {
      ListLevelScoreChecked: [],
      IsCustom: true,
      ListCustomRanges: [{}],
    },
  },
}

export const SCORE_MODE_ID = {
  CREDIT_RISK: 1,
  PERFORMANCE: 2,
  CORPORATE_RISK: 3,
}
